import { Component, OnInit } from '@angular/core';
import {PageService} from "../../services/page.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-naac',
  templateUrl: './naac.component.html',
  styleUrls: ['./naac.component.css']
})
export class NaacComponent implements OnInit {

  constructor(private pService:PageService,private route: ActivatedRoute,
      private router: Router) { }

  isLoaded:boolean = false;

  content:any;

  ngOnInit() {

  	this.pService.getPage("naac").subscribe((result:any)=>{
  	  this.content = result;
  	  console.log(result);
      this.isLoaded = true;
  	})
  }

}



// WEBPACK FOOTER //
// ./src/app/components/naac/naac.component.ts